"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dat(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M16.3106 4.46414C16.6046 4.46414 16.8416 4.55414 17.0209 4.73339C17.2001 4.91264 17.2894 5.14889 17.2894 5.44364V14.1991C17.2894 15.1966 17.0531 16.1064 16.5791 16.9254C16.1273 17.7228 15.4714 18.3855 14.6786 18.8454C13.8851 19.3059 12.9956 19.5361 12.0094 19.5361C11.0239 19.5361 10.1216 19.3059 9.30188 18.8454C8.50916 18.3855 7.85319 17.7228 7.40138 16.9254C6.94088 16.1064 6.71063 15.1974 6.71063 14.1991C6.71063 13.2009 6.92138 12.2979 7.34438 11.4916C7.77938 10.6726 8.36813 10.0321 9.11063 9.57164C9.86588 9.11114 10.7044 8.88014 11.6254 8.88014C12.3346 8.87494 13.0358 9.0293 13.6773 9.33179C14.3188 9.63428 14.884 10.0772 15.3311 10.6276V5.44364C15.3311 5.14889 15.4211 4.91264 15.6004 4.73339C15.7924 4.55349 16.0476 4.45671 16.3106 4.46414ZM12.0094 17.8081C12.6499 17.8081 13.2259 17.6551 13.7374 17.3476C14.258 17.0324 14.683 16.5812 14.9666 16.0426C15.2606 15.4914 15.4084 14.8771 15.4084 14.1991C15.4084 13.5211 15.2606 12.9121 14.9659 12.3751C14.6856 11.8391 14.2598 11.393 13.7374 11.0881C13.2259 10.7686 12.6499 10.6081 12.0094 10.6081C11.3696 10.6081 10.7869 10.7686 10.2619 11.0881C9.74528 11.4003 9.32123 11.8446 9.03338 12.3751C8.73938 12.9121 8.59238 13.5204 8.59238 14.1991C8.59238 14.8779 8.73938 15.4914 9.03338 16.0419C9.32454 16.5752 9.74781 17.0249 10.2626 17.3476C10.7876 17.6551 11.3696 17.8081 12.0101 17.8081H12.0094Z", fill: color }));
}
exports["default"] = dat;
//# sourceMappingURL=dat.js.map